import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
// import { FontWeightEnum, TextVariantColorEnum } from '@app/common';
import { useRootStore } from '../../../../providers/root-store-provider';
import { Button } from '../../form/button/button';
// import { LookupKeyEnum } from '../../../../defs/api';
import { BasePremiumPlusDialog } from '../base-premium-plus-dialog';
// import { ValueAmount } from '../../value/amount/value-amount';
// import { Confirm } from '../../confirm/confirm';
// import { routes } from '../../../../config/routes';
import { Tooltip } from '../../tooltip/tooltip';

export const GetPremiumPlusDialog: React.FC = observer(() => {
    const { t } = useTranslation();
    const { premiumPlusDialogStore } = useRootStore();
    // const { premiumPlusDialogStore, stripeStore, authStore } = useRootStore();

    // React.useEffect(() => {
    //     stripeStore.fetchLookupKey();
    // }, []);

    return (
        <>
            <BasePremiumPlusDialog
                opened={premiumPlusDialogStore.opened}
                close={() => premiumPlusDialogStore.close()}
                locked
                content={
                    <>
                        <div className="mx-auto mb-medium max-w-[36rem] text-center text-[3.8rem] font-bold leading-[4.6rem] text-neutral-white vl:mx-0 vl:text-left">
                            {t(`layout.subscription.event.${premiumPlusDialogStore.type}.title`)}
                        </div>
                        <div className="mx-auto mb-medium max-w-[38rem] text-center text-[1.8rem] font-bold leading-[2.4rem] text-neutral-white vl:mx-0 vl:text-left">
                            {t(`layout.subscription.event.${premiumPlusDialogStore.type}.description`)}
                        </div>
                        <div className="mb-medium flex flex-col gap-[1rem] vl:mb-0 vl:flex-row vl:items-center">
                            <Tooltip content={t('blocks.pricing.premiumPlus.comingSoonTooltip')} position="top">
                                <Button variant="white" shadow size="vlarge" disabled>
                                    {t('blocks.pricing.premiumPlus.action.comingSoon')}
                                </Button>
                            </Tooltip>
                            {/* Upgrade for accounts with CZK payments */}
                            {/* {stripeStore.canShowPremiumPlusSwitch && !authStore.userProfile?.subscriptionEndDate ? ( */}
                            {/*    <Confirm */}
                            {/*        isProcessing={stripeStore.switchSubscriptionPriceLoading} */}
                            {/*        isLoading={stripeStore.prorationLoading} */}
                            {/*        onConfirm={async () => { */}
                            {/*            await stripeStore.switchSubscriptionPrice(LookupKeyEnum.PremiumPlusYearlyCzk); */}
                            {/*            window.location.href = `${routes.app.profile}?success=true`; */}
                            {/*        }} */}
                            {/*        variant={'positive'} */}
                            {/*        title={t(`pages.profile.settings.subscription.activeTariff.upgrade.title`)} */}
                            {/*        content={ */}
                            {/*            <Trans */}
                            {/*                i18nKey="pages.profile.settings.subscription.activeTariff.upgrade.note" */}
                            {/*                components={{ */}
                            {/*                    price: ( */}
                            {/*                        <ValueAmount */}
                            {/*                            mode={'styled'} */}
                            {/*                            fontWeight={FontWeightEnum.Bold} */}
                            {/*                            color={TextVariantColorEnum.Secondary} */}
                            {/*                            amount={stripeStore.prorationAmount?.amount || 0} */}
                            {/*                            currency={ */}
                            {/*                                stripeStore.prorationAmount?.currency.toUpperCase() || '' */}
                            {/*                            } */}
                            {/*                        /> */}
                            {/*                    ), */}
                            {/*                }} */}
                            {/*            /> */}
                            {/*        } */}
                            {/*        cancelTitle={t(`pages.profile.settings.subscription.activeTariff.upgrade.cancel`)} */}
                            {/*        confirmTitle={t(`pages.profile.settings.subscription.activeTariff.upgrade.confirm`)} */}
                            {/*    > */}
                            {/*        <Button */}
                            {/*            onClick={async () => { */}
                            {/*                await stripeStore.fetchProrationAmount(LookupKeyEnum.PremiumPlusYearlyCzk); */}
                            {/*            }} */}
                            {/*            variant="positive" */}
                            {/*            shadow */}
                            {/*            loading={stripeStore.prorationLoading} */}
                            {/*            block */}
                            {/*            size="vlarge" */}
                            {/*            type={'submit'} */}
                            {/*        > */}
                            {/*            {t('layout.subscription.wantPremiumPlus')} */}
                            {/*        </Button> */}
                            {/*    </Confirm> */}
                            {/* ) : ( */}
                            {/*    <></> */}
                            {/* )} */}

                            {/* /!* Upgrade for accounts with EUR payments *!/ */}
                            {/* {stripeStore.canShowUpgradeToPremiumPlusMessage ? ( */}
                            {/*    <Confirm */}
                            {/*        onConfirm={async () => { */}
                            {/*            window.open('https://monery.zendesk.com/hc/cs/requests/new', '_blank'); */}
                            {/*        }} */}
                            {/*        variant={'positive'} */}
                            {/*        title={t(`pages.profile.settings.subscription.activeTariff.upgradeFromEur.title`)} */}
                            {/*        content={ */}
                            {/*            <Trans i18nKey="pages.profile.settings.subscription.activeTariff.upgradeFromEur.note" /> */}
                            {/*        } */}
                            {/*        cancelTitle={t( */}
                            {/*            `pages.profile.settings.subscription.activeTariff.upgradeFromEur.cancel`, */}
                            {/*        )} */}
                            {/*        confirmTitle={t( */}
                            {/*            `pages.profile.settings.subscription.activeTariff.upgradeFromEur.confirm`, */}
                            {/*        )} */}
                            {/*    > */}
                            {/*        <Button */}
                            {/*            variant="positive" */}
                            {/*            shadow */}
                            {/*            loading={stripeStore.prorationLoading} */}
                            {/*            block */}
                            {/*            size="vlarge" */}
                            {/*            type={'submit'} */}
                            {/*        > */}
                            {/*            {t(`pages.profile.settings.subscription.activeTariff.upgradeFromEur.button`)} */}
                            {/*        </Button> */}
                            {/*    </Confirm> */}
                            {/* ) : ( */}
                            {/*    <></> */}
                            {/* )} */}
                        </div>
                    </>
                }
            />
        </>
    );
});
